export default {
    grey: '#d6d6d6',
    light_grey: '#a7a7a7',
    text_grey: '#6f6f6f',
    dark_grey: '#494949',
    background_alt: '#edebe8',
    // green: '#a8c23b',
    // green_darkened: '#98b135',
    green: '#25D287',
    blue: '#093672',
    blue_light: '#84bcda',
    red: '#f73338',
    red_darkened: '#bf2a28',
    dim_yellow: '#faecbf',

    // Manyone
    pink: '#f5e9ec',
    red_bright: '#FFDEE5',
    red_light: '#f4d2d8',
    red_strong: '#f8232d',
    gray_darker: '#666666',
    gray_dark: '#707070',
    gray_light: '#f5f6f8',
    green_light: '#e0f2eb',

    get success(): string {
        return this.green;
    },
    get danger(): string {
        return this.red;
    },
} as { [index: string]: any };
